import { getDate } from '../../../../../utils/dateUtils';
import { numberToWords } from '../../../../../utils/helper';
import { totalAmountWithoutTax } from '../../../components/TaxesCalculation';

function InvoicePdfView({ invoiceDetails, setIsDrawerOpen, setDrawerType }) {
	const {
		customer,
		invoice_number,
		date,
		due_date,
		due_amount,
		organisation,
		total_amount,
		sub_total_amount,
		invoice_products,
	} = invoiceDetails || {};

	return (
		invoiceDetails && (
			<div
				className="invoice-container"
				style={{ marginTop: '45px' }}
			>
				{/* Header Section */}
				<div className="invoice-header">
					<div>
						<h2
							className="invoice-header-heading"
							style={{ color: '#0F1C35' }}
						>
							{organisation?.organisation_name}
						</h2>
						<div style={{ marginTop: '15px', color: '#555B67' }}>
							<p>{`${organisation?.address?.state?.name || 'N/A'}`}</p>
							<p>{`${organisation?.address?.country?.name || 'N/A'}`}</p>
							{/* <p>{`${phone_mobile || 'N/A'} | ${email || 'N/A'}`}</p> */}
						</div>
					</div>
					<div className="bill-status">
						<h2>TAX INVOICE</h2>
					</div>
				</div>

				{/* Invoice Details */}
				<div
					style={{
						display: 'flex',
						gap: '60px',
						fontFamily: 'Arial',
						fontSize: '15px',
						color: '#000',
						border: '1px solid #ddd',
						padding: '13px',
					}}
				>
					{/* Left Column (Labels) */}
					<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', color: '#555B67' }}>
						<span>Invoice #</span>
						<span>Invoice Date</span>
						<span>Due Date</span>
						<span>Credit Days</span>
						{invoiceDetails?.sales_order?.order_number && <span>SO #</span>}
					</div>

					{/* Right Column (Values) */}
					<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontWeight: 700 }}>
						<span>:{invoice_number}</span>
						<span>:{getDate(date)}</span>
						<span>:{due_date ? getDate(due_date) : 'N/A'}</span>
						<span>:{customer?.credit_days}</span>
						{invoiceDetails?.sales_order?.order_number && (
							<span>:{invoiceDetails?.sales_order?.order_number || 'N/A'}</span>
						)}
					</div>
				</div>

				{/* Bill To Section */}
				<div
					style={{
						display: 'flex',
						border: '1px solid #ddd',
						padding: '13px',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					<div className="bill-to">
						<p style={{ color: '#0F1C35', fontSize: '16px', fontWeight: '600' }}>Bill To:</p>
						<h3
							style={{ fontWeight: 'bold', color: '#3B58FF', fontSize: '14px', cursor: 'pointer' }}
							onClick={() => {
								setDrawerType('customer');
								setIsDrawerOpen(true);
							}}
						>
							{customer?.name}
						</h3>
					</div>

					<div>
						{invoiceDetails.is_write_off && invoiceDetails.status === 'Write off' && (
							<p
								style={{
									fontWeight: 'bold',
									color: 'red',
									fontFamily: 'Arial',
								}}
							>
								WRITE OFF
							</p>
						)}
					</div>
				</div>
				{/* Items Table */}
				<table className="invoice-table">
					<thead>
						<tr>
							<th>#</th>
							<th>ITEM & DESCRIPTION</th>
							<th>QNTY</th>
							<th>RATE</th>
							<th>AMOUNT</th>
						</tr>
					</thead>
					<tbody>
						{invoice_products?.map((item, index) => (
							<tr key={index}>
								<td>{index + 1}</td>
								<td>
									<strong>{item.product.product_name}</strong>
									{/* <br />
									<strong
										style={{ color: 'grey' }}
										onClick={() => handleProduct(item)}
									>
										{item?.batch_no}
									</strong> */}
								</td>
								<td>
									{item?.quantity ?? ''} {item?.product?.unit?.key ?? ''}
								</td>
								<td>{Number(item.mrp).toFixed(2)}</td>
								<td>{item?.amount}</td>
							</tr>
						))}
					</tbody>
				</table>

				{/* Total Section */}
				<div className="total-section">
					<div style={{ width: '270px' }}>
						<p style={{ fontSize: '14px', color: '#555B67' }}>Total In Words</p>
						<p
							style={{ fontSize: '14px', color: '#000000', fontWeight: 'bold' }}
						>{`${numberToWords(Number(total_amount))}`}</p>
						<p style={{ fontSize: '14px', color: '#555B67' }}>Note</p>
						<p style={{ fontSize: '14px', color: '#000000', fontWeight: 'bold' }}>
							{invoiceDetails?.remarks || 'N/A'}
						</p>
					</div>
					<div
						className="totals"
						style={{
							fontSize: '14px',
							fontWeight: 'bold',
							color: '#000000',
							marginLeft: '110px',
							textAlign: 'right',
						}}
					>
						<p>Sub Total </p>
						<p>Total </p>
						<p>Balance Due</p>
					</div>
					<div style={{ color: '#555B67', textAlign: 'right' }}>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b>
							{Number(sub_total_amount).toFixed(2)}
						</p>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b> {Number(total_amount).toFixed(2)}
						</p>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b> {Number(due_amount).toFixed(2)}
						</p>
					</div>
				</div>

				{/* Footer */}
				<div style={{ textAlign: 'right' }}>
					<p>Authorized Signature: __________________________</p>
				</div>
			</div>
		)
	);
}

export default InvoicePdfView;
